import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AdPlusHeaderModule } from './app/components/adplus-header/adplus-header.module';
import { AdPlusSidenavModule } from './app/components/adplus-sidenav/adplus-sidenav.module';
import { AutocompleteEditorModule } from './app/components/ag-grid-components/autocomplete-editor/autocomplete-editor.module';
import { IhmAutocompleteChipsListModule } from './app/components/ihm-autocomplete-chips-list/ihm-autocomplete-chips-list.module';
// tslint:disable-next-line: max-line-length
import { IhmAutocompleteLargeChipsListModule } from './app/components/ihm-autocomplete-large-chips-list/ihm-autocomplete-large-chips-list.module';
import { IhmDrawerButtonModule } from './app/components/ihm-drawer-button/ihm-drawer-button.module';
import { IhmEditableLabelModule } from './app/components/ihm-editable-label/ihm-editable-label.module';
import { IhmErrorModule } from './app/components/ihm-error/ihm-error.module';
import { IhmExpandCollapsePanelModule } from './app/components/ihm-expand-collapse-panel/ihm-expand-collapse-panel.module';
import { IhmExpansionButtonModule } from './app/components/ihm-expansion-button/ihm-expansion-button.module';
import { IhmHeaderModule } from './app/components/ihm-header/ihm-header.module';
import { IhmLoadingIndicatorModule } from './app/components/ihm-loading-indicator/ihm-loading-indicator.module';
import { IhmMenuChipsListModule } from './app/components/ihm-menu-chips-list/ihm-menu-chips-list.module';
import { IhmPickListModule } from './app/components/ihm-pick-list/ihm-pick-list.module';
import { IhmSelectAllCheckboxModule } from './app/components/ihm-select-all-checkbox/ihm-select-all-checkbox.module';
import { IhmSidenavModule } from './app/components/ihm-sidenav/ihm-sidenav.module';
import { IhmSnackbarModule } from './app/components/ihm-snackbar/ihm-snackbar.module';
import { IhmSystemStatusModule } from './app/components/ihm-system-status/ihm-system-status.module';
import { IhmTimeFieldModule } from './app/components/ihm-time-field/ihm-time-field.module';
import { IhmUnifiedStartEndDatePickerModule } from './app/components/ihm-unified-start-end-date-picker/ihm-unified-start-end-date-picker.module';
import { IhmWarningMessageModule } from './app/components/ihm-warning-message/ihm-warning-message.module';
import { IhmConfigurationModule } from './app/shared/ihm-configuration/ihm-configuration.module';
import { IhmConfigurationTestingModule } from './app/shared/ihm-configuration/testing/ihm-configuration-testing.module';
import { IhmOktaModule } from './app/shared/ihm-okta/ihm-okta.module';
import { IhmPipesModule } from './app/shared/pipes/ihm-pipes.module';
import { TestService } from './app/test.service';

@NgModule({
  imports: [
    CommonModule,
    AdPlusHeaderModule,
    AdPlusSidenavModule,
    IhmHeaderModule,
    IhmSidenavModule,
    IhmErrorModule,
    IhmAutocompleteChipsListModule,
    IhmAutocompleteLargeChipsListModule,
    IhmMenuChipsListModule,
    IhmSelectAllCheckboxModule,
    IhmExpansionButtonModule,
    IhmTimeFieldModule,
    IhmUnifiedStartEndDatePickerModule,
    IhmPipesModule,
    IhmLoadingIndicatorModule.forRoot(),
    IhmConfigurationModule,
    IhmConfigurationTestingModule,
    IhmOktaModule,
    IhmWarningMessageModule,
    IhmSystemStatusModule,
    IhmExpandCollapsePanelModule,
    IhmSnackbarModule,
    IhmDrawerButtonModule,
    IhmEditableLabelModule,
    AutocompleteEditorModule,
    IhmPickListModule
  ],
  declarations: [],
  exports: [
    AdPlusHeaderModule,
    AdPlusSidenavModule,
    IhmHeaderModule,
    IhmSidenavModule,
    IhmErrorModule,
    IhmAutocompleteChipsListModule,
    IhmAutocompleteLargeChipsListModule,
    IhmMenuChipsListModule,
    IhmExpansionButtonModule,
    IhmTimeFieldModule,
    IhmUnifiedStartEndDatePickerModule,
    IhmPipesModule,
    IhmLoadingIndicatorModule,
    IhmConfigurationModule,
    IhmConfigurationTestingModule,
    IhmOktaModule,
    IhmWarningMessageModule,
    IhmSystemStatusModule,
    IhmExpandCollapsePanelModule,
    IhmSnackbarModule,
    IhmDrawerButtonModule,
    IhmEditableLabelModule,
    AutocompleteEditorModule,
    IhmPickListModule
  ],
  providers: [TestService]
})
export class IhmUICommonModule {}
